/**
 * SKE-5310. Answers `askToConnectAnotherWay`. Mounted once in root.tsx so every
 * Facebook and Instagram connect, reconnect and the campaign pass share it.
 */
import { useSyncExternalStore } from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";

import {
  answerConnectAnotherWay,
  isConnectAnotherWayOpen,
  subscribeConnectAnotherWay,
} from "../../../../api/social-account-connect/facebook/connect-another-way";
import { Modal } from "../../../../components/modal/modal";
import { Button } from "../../../../components/ui/button";
import { Z_INDEX_STEP } from "../../../../lib/modal-stack";

export function ConnectAnotherWayPrompt() {
  const open = useSyncExternalStore(
    subscribeConnectAnotherWay,
    isConnectAnotherWayOpen,
    isConnectAnotherWayOpen
  );

  if (!open) return null;

  return (
    <Modal
      show={true}
      onHide={() => answerConnectAnotherWay(false)}
      className="w-[440px] min-w-0 max-w-[calc(100vw-32px)]"
      keyboard={true}
      // Opens over the connect dialog that started the login.
      zIndexOffset={Z_INDEX_STEP * 10}
      data-testid="connect-another-way-prompt"
    >
      <div className="flex flex-col items-center text-center">
        <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-blue-100">
          <i
            aria-hidden="true"
            className="fa-regular fa-circle-question text-base text-blue-500"
          />
        </div>
        <DialogPrimitive.Title asChild>
          <h4 className="mb-1 text-base font-semibold text-neutral-900">
            Didn't see your accounts?
          </h4>
        </DialogPrimitive.Title>
        <DialogPrimitive.Description asChild>
          <p className="mb-0 font-inter text-sm text-neutral-600">
            Some Facebook Pages and Instagram accounts aren't part of a business
            portfolio. You can connect them another way.
          </p>
        </DialogPrimitive.Description>
      </div>
      <div className="flex items-center justify-end gap-3">
        <Button
          variant="blue-secondary"
          size="md"
          onClick={() => answerConnectAnotherWay(false)}
        >
          Not now
        </Button>
        <Button
          variant="blue-primary"
          size="md"
          onClick={() => answerConnectAnotherWay(true)}
        >
          Connect another way
        </Button>
      </div>
    </Modal>
  );
}
